import { render, staticRenderFns } from "./ComplementaryTherapies.vue?vue&type=template&id=5c8abab2&scoped=true&"
import script from "./ComplementaryTherapies.vue?vue&type=script&lang=js&"
export * from "./ComplementaryTherapies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8abab2",
  null
  
)

export default component.exports